export class IsiEvents {

    handlers = {};

    addHandler(name, handler) {
        if (!this.handlers.hasOwnProperty(name)) {
            this.handlers[name] = [];
        }
        this.handlers[name].push(handler);
        if (uiCore.getIsModeDiag() && typeof handler !== 'function') {
            console.warn(`IsiFW - IsiEvents: handler for "${name}" is not a function (or is not in the scope).`);
        }
    }

    removeHandler(name, handler) {
        if (!this.handlers.hasOwnProperty(name)) {
            return true;
        }

        for (var i in this.handlers[name]) {
            if (this.handlers[name][i] === handler) {
                this.handlers[name].splice(i, 1);
            }
        }
    }

    getHandler(name): (sender, args) => void {
        if (!this.handlers.hasOwnProperty(name)) {
            return function (sender, args) {
            };
        }

        var f = function (handlers) {
            return function (sender, args) {
                for (var i in handlers) {
                    handlers[i](sender, args);
                }
            }
        }
        return f(this.handlers[name]);
    }
}